<template>
    <div class="month">
            <table class="table-striped table table-responsive-xl">
                <thead>
                <tr>
                    <th>Тип</th>
                    <th>Характеристики</th>
                    <th>Ціна</th>
                    <th>Коментар</th>
                    <th>Відповідальний</th>
                    <th>Кластер</th>
                </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in equipments">
                        <td>{{item.type}}</td>
                        <td>{{item.description}}</td>
                        <td>
                            <div style="float: right;">{{item.price | format_price}}</div>
                        </td>
                        <td>{{item.comment}}</td>
                        <td>{{item.init_name}}</td>
                        <td>{{item.cluster_name}}</td>
                    </tr>

                    <tr v-if="equipments.length == 0">
                        <td colspan="12" style="text-align:center;padding:20px">Оргтехніки немає</td>
                    </tr>
                </tbody>
            </table>
    </div>
</template>

<script>
    export default {
        name: "equipment",
		props: {
			user: {
				type: Object,
			},
			user_id: {
				type: Number,
				default: 0,
			}
		},

        data() {
            return  {
                equipments: [],
            }
        },

		created() {
          this.getUserData();
        },

        methods : {
            async getUserData () {
				await api.get('/user/' + this.user_id + "/equipments").then(({data}) => {
					if(data.status === "operation_success") {
						this.equipments = data.data;
					}
				}).catch(err => {
					console.log(err);
				});
            },
        }
    }
</script>

<style scope>

</style>
